import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { useCreateModuleMutation } from "@modules/agreements/services/mutations";
import { ModuleFormValues, moduleSchema } from "@modules/agreements/validations";
import { CreateModuleModalProps } from "./types";

export function useCreateModuleModal({ modalRef, onRefetch }: CreateModuleModalProps) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<ModuleFormValues>({
    resolver: zodResolver(moduleSchema()),
    mode: "onBlur",
    defaultValues: {
      active: true,
    },
  });

  const { mutateAsync, isPending } = useCreateModuleMutation({
    onSuccess: () => {
      onRefetch();

      open?.({
        type: "success",
        message: translate("agreement_modules_admin.success.create"),
      });

      modalRef.current?.close();
    },
  });

  return {
    methods,
    handleConfirm: mutateAsync,
    isPending,
  };
}
